import Radio from "backbone.radio";
import { useEffect } from "react";
import { ensureErrorCallback } from "common/components/error";
import { pazienHistory } from "common/components/pazienHistory";
import { Qualifiers } from "common/components/queryBuilder/qualifiers";
import strings from "common/strings";

import { SET_ACTIVE_QUALIFIERS } from "common/actions/common";
import { AuthRoute, useRouteMatch, useParams, useQueryParameters } from "extensions/react-router";

export function SearchRouter() {
    const { url } = useRouteMatch();
    return (
        <AuthRoute
            path={`${url}/search/:txn_type?/:qualifiers?`}
            authenticated={(state) => state.permissions.user_permissions.has_transaction_details}
            component={SearchPage}
        />
    );
}

export function SearchPage() {
    const { txn_type, qualifiers: search_options } = useParams();
    const queryParams = useQueryParameters();

    useEffect(() => {
        async function main() {
            try {
                const { SearchView } = await import(
                    /* webpackChunkName: "transactions_search_view" */
                    /* webpackPrefetch: true */
                    "./searchView"
                );
                
                const supportedSections = ["sales_refunds", "chargebacks", "authorizations"];
                // Backwards compatibility with old urls: section:sales_refunds
                // Try to split on a colon and if it is a supported section
                // eslint-disable-next-line no-unused-vars,prefer-const
                let [category, normalized_txn_type = txn_type] = (txn_type || supportedSections[0]).split(":");
                if (!supportedSections.includes(normalized_txn_type)) {
                    normalized_txn_type = supportedSections[0];
                }
                
                const qualifiers = new Qualifiers({
                    value: search_options || ""
                });
                
                // Clean up the url
                pazienHistory.navigateWithParams(`search/${normalized_txn_type}/${qualifiers.toString(true)}`, { replace: true, extraParams: queryParams });

                SET_ACTIVE_QUALIFIERS(qualifiers.toString(true));
                
                Radio.channel("main").request("show:app:view", new SearchView({
                    name: strings.page_search,
                    hideDatePicker: true,
                    qualifiers,
                    queryParams,
                    txn_type: normalized_txn_type
                }));
            } catch (error) {
                ensureErrorCallback(error);
            }
        }

        main();
    }, [txn_type, search_options, queryParams]);

    return null;
}
